/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   Simple accordion pattern example
 */

'use strict';

class Accordion {
  constructor(domNode) {
    this.rootEl = domNode;
    this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');

    const controlsId = this.buttonEl.getAttribute('aria-controls');
    this.contentEl = document.getElementById(controlsId);

    this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

    // add event listeners
    this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.toggle(!this.open);
  }

  toggle(open) {
    // don't do anything if the open state doesn't change
    if (open === this.open) {
      return;
    }

    // update the internal state
    this.open = open;

    // handle DOM updates
    this.buttonEl.setAttribute('aria-expanded', `${open}`);
    if (open) {
      this.contentEl.removeAttribute('hidden');
      this.rootEl.closest('.item').classList.add('active');
    } else {
      this.contentEl.setAttribute('hidden', '');
      this.rootEl.closest('.item').classList.remove('active');
    }
  }

  // Add public open and close methods for convenience
  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}

// init accordions
const accordions = document.querySelectorAll('.accordion span.accordion-buttonwrapper');
accordions.forEach((accordionEl) => {
  new Accordion(accordionEl);
});

(() => {
  const transitionHandler = (e) => {
    if (typeof e.target.matches !== 'function') {
      return
    }

    if (!e.target.matches(".accordion .item .content")) {
      return
    }

    e.preventDefault();
    e.stopPropagation();

    if (!e.currentTarget.parentNode) {
      return;
    }

    // from the CSS transition we know the last event will be the padding-bottom
    const isLastEvent = e.originalEvent.propertyName === 'padding-bottom';
    // we only want to act upon active elements
    const isActive = e.currentTarget.parentNode.classList.contains('active');

    if (isLastEvent && isActive) {
      e.currentTarget.parentNode.scrollIntoView()
    }
  }

  document.addEventListener('webkitTransitionEnd', transitionHandler)
  document.addEventListener('transitionend', transitionHandler)

  document.addEventListener('click', e => {
    if (typeof e.target.matches !== 'function') {
      return
    }

    if (!e.target.matches(".accordion .item .trigger")) {
      return
    }

    // Handled by accessible accordion logic
    if (e.target.closest('.accordion').querySelector('.accordion-buttonwrapper')) {
      return
    }

    e.preventDefault();
    e.stopPropagation();

    const $item = e.target.closest('.item');

    for (let sibling of $item.parentNode.querySelectorAll('.item.active:not(.self-closable-only)')) {
      if (sibling === $item) {
        continue
      }

      sibling.classList.remove('active')

      if (sibling.querySelector('.content'))  {
        sibling.querySelector('.content').classList.remove('show')
      }
    }

    $item.classList.toggle('active')

    if ($item.querySelector('.content'))  {
      $item.querySelector('.content').classList.toggle('show')
    }
  });
}) ()